/**
 * Nordic Frost — shared behaviour for the Cloud surfaces (and any page that
 * loads it): nav scroll state, mobile menu, back-to-top, card spotlight, and
 * the shared accordion. Side-effecting on import; safely no-ops when an element
 * isn't present on the page.
 */
import "./cookie-consent.ts"; // GDPR banner/preferences — loaded on every shared-shell page

/* ---------- nav scroll state ---------- */
const nav = document.getElementById("nav");
if (nav) {
  const onScroll = () => nav.classList.toggle("scrolled", window.scrollY > 24);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
}

/* ---------- mobile menu ---------- */
const menuBtn = document.getElementById("menuBtn");
const mobileMenu = document.getElementById("mobileMenu");
if (menuBtn && mobileMenu) {
  menuBtn.addEventListener("click", () => {
    const open = mobileMenu.classList.toggle("open");
    menuBtn.setAttribute("aria-expanded", String(open));
  });
  for (const a of mobileMenu.querySelectorAll("a")) {
    a.addEventListener("click", () => mobileMenu.classList.remove("open"));
  }
}

/* ---------- back to top ---------- */
const totop = document.getElementById("totop");
if (totop) {
  const toggleTop = () => totop.classList.toggle("show", window.scrollY > 500);
  toggleTop();
  window.addEventListener("scroll", toggleTop, { passive: true });
  totop.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
}

/* ---------- card cursor spotlight ---------- */
for (const card of document.querySelectorAll<HTMLElement>(".card")) {
  card.addEventListener("pointermove", (e) => {
    const r = card.getBoundingClientRect();
    card.style.setProperty("--mx", `${e.clientX - r.left}px`);
    card.style.setProperty("--my", `${e.clientY - r.top}px`);
  });
}

/* ---------- accordion ---------- */
for (const acc of document.querySelectorAll<HTMLElement>(".acc")) {
  const items = Array.from(acc.querySelectorAll<HTMLElement>(".acc-item"));
  const innerHeight = (item: Element) =>
    item.querySelector<HTMLElement>(".acc-body-inner")?.scrollHeight ?? 0;

  const set = (item: HTMLElement, open: boolean) => {
    const head = item.querySelector<HTMLElement>(".acc-head");
    const body = item.querySelector<HTMLElement>(".acc-body");
    if (!head || !body) return;
    item.classList.toggle("open", open);
    head.setAttribute("aria-expanded", String(open));
    body.style.maxHeight = open ? `${innerHeight(item)}px` : "0px";
  };

  for (const item of items) {
    const head = item.querySelector<HTMLElement>(".acc-head");
    if (!head) continue;
    set(item, item.classList.contains("open"));
    head.addEventListener("click", () => {
      const willOpen = !item.classList.contains("open");
      if (acc.dataset.single === "true") {
        for (const other of items) if (other !== item) set(other, false);
      }
      set(item, willOpen);
    });
  }

  window.addEventListener("resize", () => {
    for (const item of items) {
      if (item.classList.contains("open")) {
        const body = item.querySelector<HTMLElement>(".acc-body");
        if (body) body.style.maxHeight = `${innerHeight(item)}px`;
      }
    }
  });
}
